import React from "react";
import { Clock } from "lucide-react";
import { useAuth } from "@/lib/auth";
import { usePaywall } from "@/lib/access";

export function TrialBadge() {
  const { user } = useAuth();
  const { openPaywall } = usePaywall();
  if (!user?.trial_active) return null;
  return (
    <button
      type="button"
      onClick={() => openPaywall()}
      data-testid="trial-badge"
      title="Free trial — click to see plans"
      className="inline-flex items-center gap-1.5 font-mono text-[10px] tracking-[0.2em] uppercase font-extrabold border-2 border-[#111] px-2.5 py-1.5 hover:bg-[#111] hover:text-[#F4F3EC] transition-colors"
    >
      <Clock size={11} strokeWidth={2.6} />
      Trial · {user.trial_days_left}d left
    </button>
  );
}

export function TrialBanner() {
  const { user } = useAuth();
  const { openPaywall } = usePaywall();
  if (!user?.trial_active || user.trial_days_left > 1) return null;
  return (
    <div className="border-b-2 border-[#111] bg-[#F4F3EC]" data-testid="trial-last-day-banner">
      <div className="max-w-6xl mx-auto px-4 sm:px-8 py-3 flex flex-wrap items-center justify-between gap-3">
        <p className="font-display font-bold text-sm md:text-base text-[#111]">
          Your free trial ends today – keep your schedule and unlock insights from $1.99/mo
        </p>
        <button
          type="button"
          onClick={() => openPaywall()}
          data-testid="trial-banner-subscribe-btn"
          className="inline-flex items-center border-2 border-[#111] bg-[#111] text-[#F4F3EC] px-4 py-1.5 font-mono text-[10px] tracking-[0.25em] uppercase font-extrabold hover:bg-[#F4F3EC] hover:text-[#111] transition-colors"
        >
          Subscribe
        </button>
      </div>
    </div>
  );
}
